<template>
    <div class="textarea" contenteditable="true" v-once v-html="value" :value="value" @input="changeText"></div>
</template>

<script>
    // ideas from here: https://jsfiddle.net/likemusicev/rqv78hkb/
    export default{
        name: 'editDiv',
        props: {
            value: {
                type: String,
                default: ''
            },
        },
        data(){
            return {
            }
        },
        watch: {
            value: function (newValue) {
                if (document.activeElement == this.$el) {
                    return;
                }

                this.$el.innerHTML = newValue;
            }
        },
        methods: {
            changeText(){
                this.$emit('input', this.$el.innerHTML);
            }
        }
    }
</script>

<style>
    .textarea {
        border: 2px solid #456CEB;
        border-radius: 3px;
    }

        .textarea[contentisEditing]:empty::before {
            content: "請輸入心得討論";
            color: gray;
        }
</style>
